var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMemory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9971 2.33496C21.6159 2.33496 22.2099 2.58006 22.6475 3.01758C23.085 3.45516 23.3311 4.04913 23.3311 4.66797V23.335C23.3309 23.9536 23.0849 24.5469 22.6475 24.9844C22.2099 25.422 21.6159 25.668 20.9971 25.668H6.99707C6.37839 25.6679 5.78516 25.4218 5.34766 24.9844C4.91019 24.5469 4.66419 23.9536 4.66406 23.335V17.0459C4.66538 16.5846 4.80324 16.1339 5.06055 15.751L6.99707 12.835V4.66797C6.99707 4.04913 7.24308 3.45516 7.68066 3.01758C8.11824 2.58003 8.71225 2.33496 9.33105 2.33496H20.9971Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9974 4.66602H18.6641V10.4993H20.9974V4.66602Z",
    fill: "#FFF8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 4.66699H14V10.5003H16.3333V4.66699Z",
    fill: "#FFF8B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6693 4.66602H9.33594V10.4993H11.6693V4.66602Z",
    fill: "#FFF8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMemory);
export default __webpack_public_path__ + "static/media/icon_memory.2f40ab4233a9c0364fd87b48b3dc281d.svg";
export { ForwardRef as ReactComponent };